"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckFlatbedTeam = function SvgIconTruckFlatbedTeam(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck flatbed team icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Flatbed Team Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.944 30.683v-.106a4.642 4.642 0 00-3.205-4.426 16.041 16.041 0 00-.847-.249c.02-.02.038-.042.057-.063h9.162v-9.365h7.153L46 22.789v7.894h-3.158a4.739 4.739 0 01-4.737 4.737 4.738 4.738 0 01-4.736-4.737h-4.425zm11.53-11.84h-3.947v3.946h7.047l-3.1-3.946zm-24.113 4.309c.898-1.461 1.427-3.182 1.427-4.88 0-.725-.102-1.427-.293-2.092a4.66 4.66 0 012.69-.85 4.691 4.691 0 014.686 4.685c0 2.653-2.09 5.858-4.686 5.858-1.582 0-2.976-1.19-3.824-2.721zm4.356 10.921v-3.69a5.23 5.23 0 00-.783-2.751l.251-.002c2.153 0 3.82.394 4.84.724a2.326 2.326 0 011.603 2.223v2.91a.586.586 0 01-.585.586h-5.326zm17.388-1.02a2.369 2.369 0 100-4.736 2.369 2.369 0 000 4.735zM15.472 18.271c0 2.918-2.352 6.443-5.272 6.443-2.92 0-5.271-3.525-5.271-6.443A5.278 5.278 0 0110.2 13a5.278 5.278 0 015.272 5.272zM2.586 35.258A.586.586 0 012 34.673v-4.29c0-1.236.787-2.346 1.958-2.763 1.47-.523 3.748-1.148 6.242-1.148 2.495 0 4.772.625 6.243 1.148a2.942 2.942 0 011.958 2.764v4.289a.586.586 0 01-.586.585H2.585z"
  }));
};

var _default = SvgIconTruckFlatbedTeam;
exports.default = _default;